module.exports = __webpack_public_path__ + "static/media/idfm-logo.13f5e5a9.png";